<template>
  <Accordion
    v-if="props.tabs.length > 0"
    value="0"
    class="custom-accordion"
    :class="color === 'white' ? 'white' : ''"
  >
    <AccordionPanel
      v-for="(tab, index) in enabledTabs"
      :key="tab?.title + index"
      :value="tab?.title + index"
    >
      <AccordionHeader>{{ tab?.title }}</AccordionHeader>
      <AccordionContent>
        <div class="w-full gap-4 lg:gap-5 grid">
          <div
            v-html="tab?.description"
            class="text-base md:text-lg font-medium"
          ></div>
          <AtomsButton
            v-if="tab?.button?.enabled"
            :label="tab?.button?.label"
            :link="tab?.button?.link"
            :target="tab?.button?.target"
            :icon="tab?.button?.icon"
            :iconPosition="tab?.button?.iconPosition"
            :color="tab?.button?.color"
            :disabled="tab?.button?.disabled"
          />
        </div>
      </AccordionContent>
    </AccordionPanel>
  </Accordion>
</template>

<script setup>
const props = defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  color: {
    type: String,
  },
});

const enabledTabs = computed(() => props.tabs.filter((tab) => tab.enabled));
</script>
